const BaseURL = "https://flexibees.appinessworld.com/api/admin";
const BaseURLForMapping = "https://flexibees.appinessworld.com/api";
const SocketURL = "ws://flexibees.appinessworld.com/ws";
const EditURL = "https://flexibees.appinessworld.com/api"
const CommonUrl = "https://flexibees.appinessworld.com/api/common";

export const API = {
  LOGIN: `${BaseURL}/login/`,
  CHANGE_PASSWORD: `${BaseURL}/change-password/`,
  FORGOT_PASSWORD: `${BaseURL}/forgot-password/`,
  //CONFIGURATION
  GET_CONFIGURATION: `${BaseURL}/configuration/`,
  CREATE_CONFIGURATION: `${BaseURL}/configuration/`,
  ADD_FUNCTIONTAG: `${BaseURL}/function/`,
  GET_FUNCTIONS: `${BaseURL}/function/`,
  GET_CONFIG_DROPDOWN: `${BaseURL}/config-dropdowns/`,
  ADD_SKILLTAG: `${BaseURL}/skill/`,
  ADD_DOMAINTAG: `${BaseURL}/domain/`,
  ADD_ROLETAG: `${BaseURL}/role/`,
  SEARCH_CONFIGURATION: `${BaseURL}/configuration-search/`,
  ADD_OTHERTAG: `${BaseURL}/configuration/`,
  GET_ROLLS_SKILL_MAPPING: `${BaseURLForMapping}/common/roles-skill`,
  GET_CUSTOM_ROLES_LISTING: `${BaseURLForMapping}/common/custom-role-list/`,
  GET_CUSTOM_SKILLS_LISTING: `${BaseURLForMapping}/common/custom-skill-list/`,
  ACCEPT_CUSTOM_ROLE: `${BaseURLForMapping}/common/approve-role-status/update/`,
  ACCEPT_CUSTOM_SKILL: `${BaseURLForMapping}/common/approve-skills-status/update/`,
  SET_EDITED_ROLES: `${EditURL}/common/custom-role/update/`,
  SET_EDITED_SKILLS: `${EditURL}/common/custom-skill/update/`,

  GET_USERS: `${BaseURL}/admin-list`,
  SEARCH_USERS: `${BaseURL}/search-admin`,
  ADD_USER: `${BaseURL}/add-admin/`,
  GET_SKILLS: `${BaseURL}/skill/`,

  MEDIA_UPLOAD: `${BaseURL}/media-upload/`,
  VIEW_PROFILE: `${BaseURL}/view-profile/`,
  EDIT_PROFILE: `${BaseURL}/edit-profile/`,
  EDIT_USER: `${BaseURL}/edit-admin`,
  DELETE_USER: `${BaseURL}/delete-admin`,
  GET_NOTIFICATION: `${BaseURL}/notification`,
  NOTIFICATION_COUNT: `${SocketURL}/admin-notification`,

  GET_CANDIDATES: `${BaseURL}/all-candidates-list`,
  GET_CANDIDATES_FILTERS: `${BaseURL}/all-candidates-filters/`,
  GET_CANDIDATE_DETAILS: `${BaseURL}/candidate-detail`,
  CHANGE_CANDIDATE_EMAIL: `${BaseURL}/change-email/`,
  HIRE_NOT_TO_HIRE: `${BaseURL}/hire-not-hire-candidate`,
  GET_CANDIDATES_CITY_LIST: `${BaseURL}/all-candidates-city-list`,
  GET_CANDIDATE_TIMELINE: `${BaseURL}/candidate-timeline`,
  DOWNLOAD_CANDIDATE_TIMELINE: `${BaseURL}/candidate-timeline-download`,
  LIST_ACTIVITY_CARDS: `${BaseURL}/list-activity-card`,
  ADD_ACTIVITY_CARD: `${BaseURL}/add-activity-card/`,
  EDIT_ACTIVITY_CARD: `${BaseURL}/update-activity-card`,
  WEB_USERS_LIST: `${BaseURL}/web-users-list`,
  DOWNLOAD_FLEXIBEES_RESUME: `${BaseURL}/candidate-resume-download`,
  APP_INFO: `${BaseURL}/app-info/`,
  CANDIDATE_JOURNEY: `${BaseURL}/candidate-journey`,
  CANDIDATE_JOURNEY_FEEDBACK: `${BaseURL}/candidate-feedback-list`,
  VIEW_PROJECT: `${BaseURL}/view-project`,
  VIEW_PROJECT_INFO: `${BaseURL}/project-info`,

  CONFIG_LIST:`${BaseURL}/congigparams/list`,
  UPDATE_CONFIG_VALUES:`${BaseURL}/congigparams`,
  CANDIDATE_FUNCTION_CHANGE:`${BaseURL}/candidate-function-change`,
  JOB_LISTING:`${BaseURL}/jobs/list`,
  JOB_STATUS:`${BaseURL}/job/status`,
  EDIT_JOB_DETIALS:`${BaseURL}/job`,
  Job_INTERVIEW_SCHEDULE:`${BaseURL}/job/schedule`,
  CANDIDATE_JOB_STATUS:`${BaseURL}/job/candidate-job-status/list`,
  FEEDBACK_STATUS:`${BaseURL}/job/update-feedback`,
  ASSET_UPLOAD:`${CommonUrl}/asset-upload`,
  NOTIFY_NEXT_CANDIDATES:`${BaseURL}/notify-candidates`,
  MARKETPLACE_UPDATE:`${BaseURL}/candidate-detail-mp-update`,
  REJECT_SELECTED_CANDIDATE:`${BaseURL}/job/reject-selected-candidate`,
  CANDIDATE_DETAILS_UPDATE:`${BaseURL}/candidate-details-update/`,
  PROJECT_LAUNCH_LIST:`${BaseURL}/project/launch/list`,
  EDIT_PROJECT_NOTES:`${BaseURL}/project/launch/update`,
  PROJECT_DETAILS_DOWNLOAD:`${BaseURL}/project/launch/download`,
  // sso related apis

  SSO_REGISTER: `${BaseURL}/oauth-client/register/`,
  SSO_USER_LIST: `${BaseURL}/oauth-client/list/`,
  SSO_USER_DELETE: `${BaseURL}/oauth-client`,

  //MP LAUNCHES
  MP_LAUNCH_LIST:`${BaseURL}/job/launch/list`,
  MP_LAUNCH_LIST_UPDATE:`${BaseURL}/job/launch/update/`,
  MP_LAUNCH_LIST_EXPORT:`${BaseURL}/job/launch/download`,

  GET_RECRUITMENT: `${BaseURL}/recruitment`,
  GET_WORKFLOW_FINAL: `${BaseURL}/final-candidates`,
  CREATE_PROJECT_LAUNCH:`${BaseURL}/launch-project/`,
  UPDATE_PROJECT_LAUNCH:`${BaseURL}/update-project-launch`


};
